import { gql } from "@apollo/client";

export default gql`
  mutation ExportEngagementSurveyToCsvMutation(
    $complianceProgramId: Int!
    $groupBy: EngagementSurveyReportGroupBy
  ) {
    exportComplianceProgramEngagementSurveyToCsv(
      complianceProgramId: $complianceProgramId
      groupBy: $groupBy
    ) {
      complianceProgram {
        id
      }
    }
  }
`;
